import { Formik, useField, Form } from 'formik'
import React, { useContext, useRef, useEffect } from 'react'
import AppNavigation from '../../AppNavigation'
import { AppContext } from '../../../App'
import * as Yup from 'yup'
import axios from 'axios'
import config from '../../../config.json'

export default function UnderlaymentCoverageDetails() {
    const {
      setAppHeader,
      setCurrentStep,
      stepsCompleted,
      setStepsCompleted,
        setCoverageDetails,
        setCoverageData,
      coverageData,
      unit,
        setUnit,
        productSelected,
   } = useContext(AppContext)

   const CustomInputTotalArea = ({ label, ...props }) => {
      const [field, meta] = useField(props)
      return (
         <div className="row form-group p-1">
               <div className="col-xs-12 col-sm-8">
                  <div className="row p-1">
                     <div className="col-xs-12 col-sm-6">
                           <label htmlFor={props.id || props.name}>{label}</label>
                     </div>
                     <div className="col-xs-12 col-sm-6">
                           <input className="text-input" {...field} {...props} />
                           { meta.touched && meta.error ? (
                              <div className="error">{ meta.error }</div>
                           ) : null }
                     </div>
                  </div>
               </div>
               <div className="col-xs-12 col-sm-4">
                  <label className="unit-label">
                     ft&#178;
                     <input type="radio" name="radio-unit" checked={unit==="sqft"} onChange={e => setUnit(e.currentTarget.value)} id="radio-unit-sqft" value="sqft" />
                  </label>
                  <label className="unit-label">
                     m&#178;
                     <input type="radio" name="radio-unit" checked={unit==="mm"} onChange={e => setUnit(e.currentTarget.value)} id="radio-unit-sqm" value="mm" />
                  </label>
               </div>
         </div>
      )
   }

    const CustomTextInput = ({ label, ...props }) => {
        const [field, meta] = useField(props)
        return (
            <div className="row form-group p-1">
                <div className="col-xs-12 col-sm-4">
                    <label htmlFor={props.id || props.name}>{label}</label>
                </div>
                <div className="col-xs-12 col-sm-4">
                    <input className="text-input" {...field} {...props} />
                    {meta.touched && meta.error ? (
                        <div className="error">{meta.error}</div>
                    ) : null}
                </div>
            </div>
        )
    }
    const CustomSelect = ({ label, modalFor, ...props }) => {
        const [field, meta] = useField(props, 'checkbox')
        return (
            <div className="row form-group p-1">
                <div className="col-xs-12 col-sm-4">
                    <label htmlFor={props.id || props.name}>{label}</label>
                </div>
                <div className="col-xs-12 col-sm-4">
                    <select {...field} {...props} id={props.name} />
                    {meta.touched && meta.error ? (
                        <div className="error">{meta.error}</div>
                    ) : null}
                </div>
            </div>
        )
    }

    useEffect(() => {
    }, [coverageData])


    const underlaymentCalculation = (formData) => {

        const apiUrlRoot = config.underlaymentEndpoint
        const { totalArea: area } = formData
        let { thicknessCoverage, colors } = formData
        const totalArea = area
        let thicknessCoverageText, thicknessCoverageCoverage, colorText, colorSku

        if (!thicknessCoverage) {
            thicknessCoverageCoverage = productSelected.coverage;
        } else {
            [thicknessCoverageText, thicknessCoverageCoverage] = thicknessCoverage.split('|');
        }

        if (colors) {
            [colorSku, colorText] = colors.split('|');
        }



        let url = `${apiUrlRoot}/GetUnderlaymentResultByProjectAreaCoverage/${unit}/${totalArea}/${thicknessCoverageCoverage}`
      axios.get(url)
          .then(res => {
              setCoverageData({ coverage: res.data.coverage, unitsRequiredDefault: res.data.unitsRequiredDefault, actualUnitsRequiredDefault: res.data.actualUnitsRequiredDefault, colorSku: colorSku, thicknessCoverageText: thicknessCoverageText, colorText: colorText })
      })
      .catch(err => {
         console.log(err)
      })

        
    }


    const handleFormSubmission = (formData) => {
      // Add the input data to state of App.
      setCoverageDetails({ formData })
      // Update the current step.
      setCurrentStep({ step: "underlaymentQuoteCreated" })
      // Update the steps completed to include this step.
      stepsCompleted.push("Provide Coverage Details")
      setStepsCompleted(stepsCompleted)
      // Set the appHeader for Step state.
      setAppHeader("Quote created.")
      // Calculate underlayment amount required.
        underlaymentCalculation(formData)
    }

    return (
      <React.Fragment>
         <div className="col-xs-12 col-md-9 col-md-push-3">
            <h3>Provide Coverage Details</h3>
            <Formik
                    initialValues={{ totalArea: '', unit: 'sqft' }}
               validateOnChange={false}
               validateOnBlur={false}
               validationSchema={Yup.object().shape({
                  totalArea: Yup.number()
                        .required('This field is required.')
                        .positive('This value must be positive.'),
                  unit: Yup.string()
                       .required('Select unit')
               })}
               onSubmit={ (values) => {
                  handleFormSubmission(values)
               } }
               >
               { // Render props
               props => (
                  <Form>
                       <CustomInputTotalArea label="Total Area" name="totalArea" placeholder="Enter total area" />
                       {
                           (productSelected.thicknessCoverage && productSelected.thicknessCoverage.length > 0) &&
                           <CustomSelect label="Thickness" name="thicknessCoverage" id="thicknessCoverage">
                               <option value=""></option>
                               {
                                   JSON.parse(productSelected.thicknessCoverage).map((t, index) => {
                                       return (
                                           unit === "sqft" ? (
                                               <option key={t.ThicknessTextInches} value={`${t.ThicknessTextInches}|${t.Coverage}`}>{t.ThicknessTextInches}</option>
                                           ) : <option key={t.ThicknessTextMetric} value={`${t.ThicknessTextMetric}|${t.Coverage}`}>{t.ThicknessTextMetric}</option>
                                       )
                                   })
                               }
                           </CustomSelect>
                       }
                       {
                           (productSelected.colors && productSelected.colors.length > 0) &&
                           <CustomSelect label="Colors" name="colors">
                               <option value=""></option>
                               {
                                   JSON.parse(productSelected.colors).map((t, index) => {
                                       return (
                                           <option key={t.Name} value={`${t.Sku}|${t.Name}`}>{t.Name}</option>
                                       )
                                   })
                               }
                           </CustomSelect>
                       }

                     <button className="btn btn-primary" type="submit">{ props.isSubmitting ? 'Loading...' : 'CALCULATE' }</button>
                  </Form>
               )}
            </Formik>
         </div>
         <AppNavigation />
      </React.Fragment>
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/underlayment/UnderlaymentCoverageDetails.js